export default {
  ACTIVITY: "activity",
  VIDEO: "video",
  BLOG_POST: "blog post",
  POLL: "poll",
  GAME: "game",
};
